export interface Ioffice {
  ID: number;
  Name: string;
  Direccion: string;
  Referencia: string;
  Coordenadas: string;
  Descripcion: string;
  Status: boolean;
  UserCreation: string;
  DateCreation: string;
  UserLastUpdate: string;
  DateLastUpdate: string;
  empresaID: number;
  empresaName: string
}


export class Office implements Ioffice {
  constructor(
    public ID: number,
    public Name: string,
    public Direccion: string,
    public Referencia: string,
    public Coordenadas: string,
    public Descripcion: string,
    public Status: boolean,
    public UserCreation: string,
    public DateCreation: string,
    public UserLastUpdate: string,
    public DateLastUpdate: string,
    public empresaID: number,
    public empresaName: string
  ) {
    this.ID = ID;
    this.Name = Name;
    this.Direccion = Direccion;
    this.Referencia = Referencia;
    this.Coordenadas = Coordenadas;
    this.Descripcion = Descripcion;
    this.Status = Status;
    this.UserCreation = UserCreation;
    this.DateCreation = DateCreation;
    this.UserLastUpdate = UserLastUpdate;
    this.DateLastUpdate = DateLastUpdate;
    this.empresaID = empresaID;
    this.empresaName = empresaName;
  }

}

